import { MenuIcon } from "lucide-react"
import { Button } from "./ui/button"
import type { ComponentProps, ReactNode } from "react"
import { cn } from "~/lib/utils"
import { SidebarTrigger } from "./ui/sidebar"

export function AppHeader({
	children,
	actions,
	className,
	contentClassName,
	triggerClassName,
	sidebarToggle,
	variant = "default",
	...props
}: ComponentProps<"header"> & {
	actions?: ReactNode
	contentClassName?: string
	triggerClassName?: string
	sidebarToggle?: () => void
	variant?: "default" | "outline"
}) {
	return (
		<header
			className={cn(
				"sticky top-0 z-10 flex items-center px-4",
				variant === "outline"
					? "border-b border-stroke bg-background"
					: "bg-background-secondary",
				className,
				"h-14 min-h-14 max-h-14 shrink-0"
			)}
			{...props}
		>
			{sidebarToggle ? (
				<Button
					variant="ghost"
					size="icon-md"
					className="mr-2 md:hidden in-[.orbit-app-shell]:hidden"
					aria-label="Toggle Sidebar"
					onClick={sidebarToggle}
				>
					<MenuIcon />
				</Button>
			) : (
				<SidebarTrigger
					className={cn(
						"mr-2 md:hidden in-[.orbit-app-shell]:hidden",
						triggerClassName
					)}
				/>
			)}
			<div className={cn("min-w-0 grow", contentClassName)}>{children}</div>
			{actions ? (
				<div className="flex shrink-0 items-center gap-2.5 text-icons">
					{actions}
				</div>
			) : null}
		</header>
	)
}
